export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-5xl mx-auto">
        <div className="bg-background-50 rounded-2xl overflow-hidden border border-background-200/70">
          <div className="flex flex-col lg:flex-row items-center">
            <div className="flex-1 p-8 md:p-12 lg:p-14">
              <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading mb-4">
                随时随地看电影
              </h2>
              <p className="text-sm text-foreground-600 leading-relaxed mb-6">
                小草影院全面适配手机、平板和电脑端。打开浏览器就能看，无需下载任何应用。高清画质、流畅播放，让你随时随地畅享电影世界。
              </p>
              <div className="flex flex-col sm:flex-row gap-4">
                <div className="flex items-center gap-3 p-3 rounded-lg bg-background-100 border border-background-200/70 flex-1">
                  <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-lg bg-primary-100">
                    <i className="ri-smartphone-line text-primary-600 text-lg"></i>
                  </div>
                  <div>
                    <div className="text-sm font-semibold text-foreground-900 whitespace-nowrap">移动端适配</div>
                    <div className="text-xs text-foreground-500">手机浏览器直接访问</div>
                  </div>
                </div>
                <div className="flex items-center gap-3 p-3 rounded-lg bg-background-100 border border-background-200/70 flex-1">
                  <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-lg bg-accent-100">
                    <i className="ri-computer-line text-accent-600 text-lg"></i>
                  </div>
                  <div>
                    <div className="text-sm font-semibold text-foreground-900 whitespace-nowrap">桌面端体验</div>
                    <div className="text-xs text-foreground-500">大屏高清沉浸观影</div>
                  </div>
                </div>
              </div>
            </div>
            <div className="flex-shrink-0 w-full lg:w-[320px] p-6 lg:p-0 lg:pr-10">
              <div className="relative max-w-[240px] mx-auto">
                <img
                  src="https://readdy.ai/api/search-image?query=Elegant%20smartphone%20mockup%20displaying%20cinema%20movie%20app%20interface%20with%20film%20posters%20and%20warm%20lighting%2C%20golden%20and%20crimson%20tones%2C%20modern%20UI%20design%2C%20cinematic%20atmosphere%2C%20sleek%20device%20presentation&width=480&height=800&seq=app-mobile-mockup&orientation=portrait"
                  alt="小草影院移动端观影体验"
                  className="w-full rounded-2xl object-cover"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}